import { useState } from 'react'
import useSWR from 'swr'
import { fetcher } from '../api/client'

export default function EmailLogsPage() {
    const { data } = useSWR<any>('/api/email-logs', fetcher)
    const [open, setOpen] = useState<string | null>(null)

    return (
        <div>
            <h1>Email Audit Log</h1>
            <div className="card">
                {!data ? <p className="muted">Loading...</p> :
                    data.items?.length === 0 ? <p className="muted">No emails sent yet.</p> :
                        <table>
                            <thead><tr><th>Date</th><th>To</th><th>Subject</th><th>Status</th><th>Opens</th><th>Clicks</th><th></th></tr></thead>
                            <tbody>
                                {data.items.map((e: any) => (
                                    <>
                                        <tr key={e.id}>
                                            <td>{new Date(e.createdAt).toLocaleString()}</td>
                                            <td>{e.emailTo}</td>
                                            <td>{e.subject}</td>
                                            <td><StatusPill status={e.status} /></td>
                                            <td>{e.openCount}</td>
                                            <td>{e.clickCount}</td>
                                            <td><button className="secondary" onClick={() => setOpen(open === e.id ? null : e.id)}>{open === e.id ? 'Hide' : 'View'}</button></td>
                                        </tr>
                                        {open === e.id && <EmailDetail key={`${e.id}-detail`} id={e.id} />}
                                    </>
                                ))}
                            </tbody>
                        </table>
                }
            </div>
        </div>
    )
}

/* Email status enum index → label (legacy int responses) */
const EMAIL_STATUS = ['Draft', 'Sent', 'Failed', 'Bounced', 'Unsubscribed'] as const

function StatusPill({ status }: { status: string | number }) {
    const label = typeof status === 'number' ? (EMAIL_STATUS[status] ?? 'Unknown') : status
    const colors: Record<string, string> = {
        Sent: '#16a34a', Failed: '#dc2626', Bounced: '#dc2626',
        Unsubscribed: '#6b7280', Draft: '#6b7280'
    }
    return <span style={{ color: colors[label] ?? '#374151', fontWeight: 600 }}>{label}</span>
}

function EmailDetail({ id }: { id: string }) {
    const { data: opens } = useSWR<any[]>(`/api/email-logs/${id}/opens`, fetcher)
    const { data: clicks } = useSWR<any[]>(`/api/email-logs/${id}/clicks`, fetcher)

    return (
        <tr>
            <td colSpan={7} style={{ background: '#f9fafb' }}>
                <div className="split">
                    <div>
                        <strong>Opens</strong>
                        {opens?.length === 0 ? <p className="muted">No opens yet.</p> :
                            <ul style={{ paddingLeft: 16, margin: 0 }}>
                                {opens?.map(o => <li key={o.id} className="muted">{new Date(o.openedAt).toLocaleString()} — {o.ipAddress ?? '?'} · {(o.userAgent ?? '').slice(0, 60)}</li>)}
                            </ul>}
                    </div>
                    <div>
                        <strong>Clicks</strong>
                        {clicks?.length === 0 ? <p className="muted">No clicks yet.</p> :
                            <ul style={{ paddingLeft: 16, margin: 0 }}>
                                {clicks?.map(c => <li key={c.id} className="muted">{new Date(c.clickedAt).toLocaleString()} — <a href={c.originalUrl} target="_blank" rel="noreferrer">{c.originalUrl}</a></li>)}
                            </ul>}
                    </div>
                </div>
            </td>
        </tr>
    )
}
